import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RoutesStatesNamesEnum } from '@uigy/shared/enums/routesStatesNames.enum';
import { EnablePageComponent } from '@uigy/modules/mini-layout/components/enable-page/enable-page.component';
import { RebootComponent } from '@uigy/modules/mini-layout/components/reboot/reboot.component';
import { ShutDownComponent } from '@uigy/modules/mini-layout/components/shut-down/shut-down.component';
import { DisableGuard } from '@uigy/core/guards/disable.guard';
import { LicenseActivationComponent } from '@uigy/modules/mini-layout/components/license-activation/license-activation.component';
import { LicensedGuard } from '@uigy/core/guards/licensed.guard';
import { UnlicensedGuard } from '@uigy/core/guards/unlicensed.guard';
import { LicenseExpiredComponent } from '@uigy/modules/mini-layout/components/license-expired/license-expired.component';
import { FactoryResetComponent } from '@uigy/modules/mini-layout/components/factory-reset/factory-reset.component';
import { CapabilityGuardCanActivate } from '@uigy/core/guards/capability.guard';
import { setCapabilitiesRouteData } from '@uigy/shared/capabilities/capabilities-route-data';
import { Capability } from '@uigy/generated/graphql';

export const routes: Routes = [
  {
    path: RoutesStatesNamesEnum.enablePage,
    canActivate: [DisableGuard, LicensedGuard],
    component: EnablePageComponent,
  },
  {
    path: RoutesStatesNamesEnum.reboot,
    component: RebootComponent,
  },
  {
    path: RoutesStatesNamesEnum.shutDown,
    component: ShutDownComponent,
    canActivate: [LicensedGuard],
  },
  {
    path: RoutesStatesNamesEnum.licenseActivation,
    component: LicenseActivationComponent,
    canActivate: [UnlicensedGuard, CapabilityGuardCanActivate],
    data: setCapabilitiesRouteData(Capability.SystemSettings),
  },
  {
    path: RoutesStatesNamesEnum.licenseExpired,
    component: LicenseExpiredComponent,
  },
  {
    path: RoutesStatesNamesEnum.factoryReset,
    component: FactoryResetComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MiniLayoutRoutingModule {}
